<script setup lang="ts">
const { features } = useLandingData()
</script>

<template>
  <section id="fitur" class="overflow-hidden bg-gradient-rintisan">
    <div class="container mx-auto pt-10 sm:pt-[94px] pb-[79px] sm:pb-[151px] px-4 relative">
      <AnimateOnScroll animation="fade-down">
        <h2 class="text-[32px] sm:text-[42px] font-medium text-white">
          Bersama Rintisan Billing,
          <br class="hidden md:block">
          Penagihan & Pembayaran
          <br class="hidden md:block">
          Mudah dilakukan
        </h2>
      </AnimateOnScroll>

      <AnimateOnScroll animation="fade-left" class="mt-11 sm:mt-12.5 w-full md:w-[120%] pr-0 md:pr-34">
        <div class="flex gap-4 overflow-x-scroll scrollX pb-4">
          <div
            v-for="(feature, index) in features"
            :key="index"
            class="max-w-[302px] min-w-[302px] h-[340px] flex flex-col justify-between rounded-lg bg-white p-5 shrink-0"
          >
            <h3 class="text-[28px] sm:text-3xl font-medium text-neutral-800">
              {{ feature.name }}
            </h3>
            <img
              class="size-12 ml-auto object-contain"
              :src="feature.icon"
              :alt="feature.name"
              loading="lazy"
            >
          </div>
        </div>
      </AnimateOnScroll>
    </div>
  </section>
</template>

<style scoped>
.scrollX::-webkit-scrollbar {
  width: 3.5px;
  height: 5px;
  opacity: 0.4;
}

.scrollX::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  opacity: 0.4;
}

.scrollX::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.2);
  opacity: 0.4;
  box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
}
</style>
